import { Link } from 'react-router-dom';
import { CATEGORIES, TOOL_ICONS, FALLBACK_ICON } from '@/lib/tools';

export default function ToolCard({ tool, index = 0 }) {
  const cat = CATEGORIES[tool.category] || CATEGORIES.utilities;
  const Icon = TOOL_ICONS[tool.id] || FALLBACK_ICON;

  return (
    <Link
      to={`/tools/${tool.id}`}
      data-testid={`tool-card-${tool.id}`}
      className="card-soft card-in group p-6 flex flex-col gap-4"
      style={{ animationDelay: `${index * 40}ms` }}
    >
      <div className="flex items-start justify-between">
        <span className={`tile ${cat.tileClass}`}>
          <Icon weight="bold" size={24} />
        </span>
        <span className={`cat-label ${cat.catClass}`}>{cat.label}</span>
      </div>
      <div>
        <h3 className="font-display font-bold text-xl leading-tight" style={{ color: 'var(--ink)' }}>
          {tool.name}
        </h3>
        <p className="text-sm text-slate-600 mt-2 leading-relaxed line-clamp-3">
          {tool.description}
        </p>
      </div>
      <div className="mt-auto pt-2 flex items-center gap-1 text-sm font-semibold text-blue-600 group-hover:translate-x-1" style={{ transition: 'transform 0.2s ease' }}>
        Open tool <span aria-hidden>→</span>
      </div>
    </Link>
  );
}
